// Copyright (c) 2024 Baidu, Inc. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import {QfLLMInfoMap} from '../interface';

/**
 * 重新排序向量模型
 */
export type RerankerModel =
    | 'bce-reranker-base_v1';

export const modelInfoMap: QfLLMInfoMap = {
    'bce-reranker-base_v1': {
        endpoint: '/reranker/bce_reranker_base',
        required_keys: ['query', 'documents'],
        optional_keys: [
            'user_id',
            'top_n',
        ],
    },
};